import { FC } from "react"
import { formatCNPJ, toDate, toDateTime, toMoney } from "../../../utils/formater"
import { Input } from "../../Input/Input"
import { MyTooltip } from "../../ToolTip/ToolTip"
import SVG from 'react-inlinesvg'


type CellDataTable = {
  object: any,
  item: any,
  indexItem: number,
  perView: number,
  indexPagination: number,
  indexHeader: number,
  changeItem: (item: any, object: any, value: any) => void
}


const CellDataTable: FC<CellDataTable> = ({
  object,
  indexItem,
  perView,
  indexPagination,
  item,
  indexHeader,
  changeItem
}) => {


  return (
    <>
      <td
        className={`${object.size == 'sm' ? '' : object.size ? object.size : 'w-25'
          } mx-1 d-flex align-items-center text-break px-2 ${object.hasOwnProperty('show') ? (object.show ? '' : 'd-none') : ''
          }`}
        style={{
          minWidth: object.size == 'sm' ? '' : '10em',
          width: object.size == 'sm' ? '100px' : '',
        }}
      >
        {indexHeader === 0 && item.subitems && (
          <span className='text-dark fw-thin me-2'>{`${indexItem + 1 + Number(perView) * indexPagination
            } `}</span>
        )}
        {object.type === 'default' && (
          <span className='text-dark fw-thin'>
            {(item[object.value] && item[object.value].length) > 30
              ? object.noLimit
                ? item[object.value]
                : `${item[object.value].substr(0, 30)}...`
              : item[object.value]}
          </span>
        )}
        {object.type === 'html' && (
          <span className='text-dark fw-thin w-100'>
            <div
              dangerouslySetInnerHTML={{ __html: `${item[object.value]}` }}
            ></div>
          </span>
        )}
        {object.type === 'money' && (
          <span className='text-dark fw-thin'>
            {toMoney(item[object.value])}
          </span>
        )}
        {object.type === 'input' && (
          <Input
            inputAttr={{
              type: 'default',
            }}
            disabled={object.disable}
            change={(value: string) => {
              changeItem(item, object, value)
            }}
            blur={() => (object.action ? object.action(item) : {})}
            value={item[object.value]}
          />
        )}
        {object.type === 'tooltip' && (
          <MyTooltip
            text={`Usado em ${item[object.value]} ${item[object.value] === 1 ? 'produto' : 'produtos'
              }`}
            products={item[object.products]}
          >
            <span className='text-dark fw-thin'>{item[object.value]}</span>
          </MyTooltip>
        )}
        {object.type === 'input-number' && (
          <Input
            inputAttr={{
              type: 'number',
            }}
            change={(value: number) => {
              changeItem(item, object, value)
            }}
            blur={() => (object.action ? object.action(item) : {})}
            value={item[object.value]}
            disabled={object.disable}
          />
        )}

        {object.type === 'input-time' && (
          <Input
            inputAttr={{
              type: 'time',
            }}
            change={(value: number) => {
              changeItem(item, object, value)
            }}
            size={'md'}
            blur={() => (object.action ? object.action(item) : {})}
            value={item[object.value]}
            disabled={object.disable}
          />
        )}
        {object.type === 'input-money' && (
          <Input
            inputAttr={{
              type: 'money',
            }}
            disabled={object.disable}
            currency='BRL'
            locale='pt-BR'
            change={(value: string) => {
              changeItem(item, object, value)
            }}
            blur={() => (object.action ? object.action(item) : {})}
            value={item[object.value]}
          />
        )}
        {object.type === 'date' && (
          <span className='text-dark fw-thin'>
            {toDate(item[object.value])}
          </span>
        )}
        {object.type === 'datetime' && (
          <span className='text-dark fw-thin'>
            {item[object.value] ? toDateTime(item[object.value]) : '-'}
          </span>
        )}
        {object.type === 'image' && (
          <>
            {item[object.value] ? (
              <a
                href={item[object.value]}
                target='_blank'
                rel='noopener noreferrer'
              >
                <img
                  src={item[object.value]}
                  alt=''
                  style={{ objectFit: 'cover' }}
                  className='w-50px h-50px bg-light rounded'
                />
              </a>
            ) : (
              <img
                src='https://via.placeholder.com/150x150'
                alt=''
                style={{ objectFit: 'cover' }}
                className='w-50px h-50px bg-light rounded'
              />
            )}
          </>
        )}
        {object.type === 'icon' && (
          <>
            {item[object.value] ? (
              <SVG
                src={item[object.value]}
                style={{
                  width: '50px',
                  height: '50px',
                }}
              />
            ) : (
              <img
                src='https://via.placeholder.com/150x150'
                alt=''
                style={{ objectFit: 'cover' }}
                className='w-50px h-50px bg-light rounded'
              />
            )}
          </>
        )}
        {object.type === 'check' && (
          <Input
            value={item[object.value]}
            checked={item[object.value]}
            change={() => (object.action ? object.action(item) : {})}
            inputAttr={{
              type: 'checkbox',
            }}
            checkSwift={true}
            size={object.size}
            disabled={object.disable}
          />
        )}

        {object.type === 'checkBox' && (
          <div className='w-100 d-flex justify-content-start'>
            <Input
              value={item[object.value]}
              checked={item[object.value]}
              change={() => (object.action ? object.action(item) : {})}
              inputAttr={{
                type: 'checkbox',
              }}
              checkSwift={false}
              size={object.size}
              disabled={object.disable}
            />
          </div>
        )}
        {object.type === 'bullet' && (
          <div className='d-flex align-items-center'>
            <span className='w-5px h-30px rounded bg-secondary me-5'></span>
            <span className='text-dark fw-thin'>{item[object.value]}</span>
          </div>
        )}
        {object.type === 'badge' && object.badge && (
          <span
            className={`badge badge-light-${object.badge[item[object.value].toLowerCase()]
              } fs-6 text-capitalize`}
          >
            {item[object.value]}
          </span>
        )}
        {object.type === 'cnpj' && (
          <span className='text-dark fw-thin'>
            {item.cnpj ? formatCNPJ(item.cnpj) : ''}
          </span>
        )}
      </td>

    </>
  )
}


export { CellDataTable }